module.exports = __webpack_public_path__ + "static/media/logo.76877974.png";